// components/AppRedirector.js

import React, { useEffect } from 'react';
import { getOS } from '../utils/device';
import { useSelector, useDispatch } from "react-redux";
import { saveOrder ,setCustomerFormData,setExampleData} from "../store/reducer/Home";
import { saveVisitUsers} from "../store/reducer/Home";
import LeafLoading from "../common/LeafLoading";

const APP_STORE_URL = 'https://apps.apple.com/app/treelix/id6752299145';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.treelix&hl=en_IN';

const AppRedirector = () => {
  const os = getOS();
  const dispatch = useDispatch();

  // function getUrlInfo() {
  //   const fullUrl = window.location.href;
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const utm_source = urlSearchParams.get('utm_source'); // Get the value for the 'name' key
  //   const utm_medium = urlSearchParams.get('utm_medium');     // Get the value for the 'id' key
  //   const referredBy = urlSearchParams.get('referredBy');     // Get the value for the 'id' key

  //   console.log('Full URL:', fullUrl);
  //   console.log('Name from URL:', name);
  //   console.log('ID from URL:', id);
  // }

  useEffect(() => {
    handleSubmit();
    // This effect runs once after the component mounts
    if (os === 'Android') {
      window.location.href = PLAY_STORE_URL;
    } else if (os === 'iOS') {
      window.location.href = APP_STORE_URL;
    }
    // No redirection for 'Web' as it will render the QR codes

  }, [os]);

  const handleSubmit = (event) => {
    // event.preventDefault();
    const fullUrl = window.location.href;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const utm_source = urlSearchParams.get('utm_source'); // Get the value for the 'name' key
    // const utm_medium = urlSearchParams.get('utm_medium');     // Get the value for the 'id' key
    const referredBy = urlSearchParams.get('referredBy');     // Get the value for the 'id' key


        let payload = {
          os:os,
          referredBy:referredBy,
          originalUrl: fullUrl,
          source:utm_source
        };
         console.log("payload", payload);
        dispatch(saveVisitUsers(payload))
          .then((res) => {
            console.log('res',res)
          })
          .catch((error) => {
            console.error("Error fetching location:", error);
          });

  };

  if (os === 'Web') {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        {/* <h1>Download Our App </h1> */}
        <h1>Download Our App, Your green journey starts here.</h1>
        <p>Scan the QR code to download the Treelix app and get exclusive access to our hand-selected plants and seeds.</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '50px', marginTop: '30px' }}>
          <div>
            <p>App Store</p>
            {/* Replace with your actual QR code image for App Store */}
            <img 
              src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${APP_STORE_URL}`} 
              alt="App Store QR Code"
              style={{ width: '150px', height: '150px' }}
            />
          </div>
          <div>
            <p>Google Play</p>
            {/* Replace with your actual QR code image for Google Play */}
            <img 
              src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${PLAY_STORE_URL}`} 
              alt="Google Play QR Code"
              style={{ width: '150px', height: '150px' }}
            />
          </div>
        </div>
      </div>
    );
  }

  // Return a message for devices that are being redirected
  return (
    <div style={{ textAlign: 'center', padding: '20px' }}>
     <LeafLoading />
    </div>
  );
};

export default AppRedirector;